import { putWithToken } from 'api/network';

export default async function UpdateAuctionDateByPortfolioId(portfolioId, auctionDate) {
  const url = `/api/underwrite/auction/${portfolioId}/updateAuctionDate`;
  const response = await putWithToken(url, auctionDate);
  const data = await response.json();
  return data;
}